import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { AffiliateResponse } from './AffiliateInterface'
import WalletService from './AffiliateService'

interface WalletState {
  affiliate: AffiliateResponse | null
}

const initialState: WalletState = {
  affiliate: null,
}

export const getAffiliateThunk = createAsyncThunk(
  'affiliate/getAffiliateThunk',
  async (_, { rejectWithValue }) => {
    try {
      return await WalletService.getAffiliate()
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

const affiliateSlice = createSlice({
  name: 'affiliate',
  initialState,
  reducers: {},

  extraReducers: builder => {
    builder

      .addCase(getAffiliateThunk.fulfilled, (state, action) => {
        state.affiliate = action.payload
      })
      .addCase(getAffiliateThunk.rejected, state => {
        state.affiliate = null
      })
  },
})

export const { actions, reducer } = affiliateSlice
